import React, { useState, useRef, useEffect } from "react";
import Logo from "../../assets/logo.png";
import Burger from "../../assets/burger.svg";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const menuRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        if (isMenuOpen) {
            menuRef.current.style.maxHeight = `${menuRef.current.scrollHeight}px`;
        } else {
            menuRef.current.style.maxHeight = "0px";
        }
    }, [isMenuOpen]);

    useEffect(() => {
        setIsMenuOpen(false);
    }, [location]);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <header
            className={`bg-white sticky top-0 py-4 px-10 flex flex-row justify-between items-center z-50 transition-all duration-300 ${
                isScrolled ? "py-4 shadow-lg" : "py-6"
            }`}
        >
            <Link to="/" className="flex items-center gap-2">
                <img className="w-6" src={Logo} alt="logo" />
                <h1 className="text-xl text-green-main font-bold">Natur Med</h1>
            </Link>
            <div className="hidden md:flex">
                <ul className="flex flex-row gap-4 font-bold text-md">
                    <Link to="/about-us" className="text-gray-700">O Nas</Link>
                    <Link to="/contact" className="text-gray-700">Kontakt</Link>
                </ul>
            </div>
            <div className="md:hidden w-7 h-7">
                <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-white">
                    <img src={Burger} alt="menu" />
                </button>
            </div>
            <div
                ref={menuRef}
                className={`absolute top-full left-0 right-0 bg-white flex flex-col items-center md:hidden transition-max-height duration-300 ease-in-out overflow-hidden ${ isScrolled || isMenuOpen ? "shadow-lg" : ""}`}
                style={{ maxHeight: "0px" }}
            >
                <ul className="flex flex-col items-center gap-2 font-bold text-md py-4">
                    <Link to="/about-us" className="text-gray-700">O Nas</Link>
                    <Link to="/contact" className="text-gray-700">Kontakt</Link>
                </ul>
            </div>
        </header>
    );
};

export default Header;
